//RFCが活性とリサーチが非活性の場合
export const mojiLimit = (moji: string, limit:number)  => {
    // 全角文字の正規表現（全角は1文字、半角は0.5文字としてカウントする）
    const fullMojiCount = moji.replace(/[^\x01-\x7E\xA1-\xDF]/g, 'aa').length/2;
    const newFullMoji = fullMojiCount <= limit ? moji : moji.slice(0, limit);
    return newFullMoji
};